import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { isEmbeddedInFrame } from '../utils/ehr-launch-utils';
import { applyRedirectFromOriginalUri, getAppsFromAccessToken } from '../okta';
import { ROUTES } from './routes';
import { registerEhrOauthHandoffListener } from '../okta/ehr-oauth-handoff';

function completeEmbeddedEhrOauthHandoff({ originalUri, tokens, history, oktaAuth }) {
  applyRedirectFromOriginalUri(originalUri);
  const authState = oktaAuth.authStateManager.getAuthState();
  const accessToken = authState?.accessToken ?? tokens.accessToken;
  const apps = getAppsFromAccessToken(accessToken);
  history.push(ROUTES.APP_SWITCHER, { apps });
}

/** Receives OAuth tokens from the EHR SSO popup when Epic sandbox blocks opener navigation. */
export default function EhrOauthHandoffListener() {
  const { oktaAuth } = useOktaAuth();
  const history = useHistory();

  useEffect(() => {
    if (!isEmbeddedInFrame()) {
      return undefined;
    }

    return registerEhrOauthHandoffListener({
      oktaAuth,
      onHandoffComplete: ({ originalUri, tokens }) =>
        completeEmbeddedEhrOauthHandoff({ originalUri, tokens, history, oktaAuth }),
    });
  }, [oktaAuth, history]);

  return null;
}
